import './styling/travelStyling.scss';

import { FC } from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { Box, Title } from '@gjensidige/builders-components';

import { Input } from '../../../components';
import { EquinorTravelValues } from '../../../utils/types';

interface PersonDetailsProps {
  control: Control<EquinorTravelValues>;
  errors: FieldErrors<EquinorTravelValues>;
}

export const PersonDetails: FC<PersonDetailsProps> = ({ control, errors }) => {
  return (
    <Box variant="form-section" className="form-section">
      <Title as="h3" size="5">
        Provide details of the Equinor employee
      </Title>
      <Input
        name="customerDetail.policyNumber"
        control={control}
        labelText="Policy number"
        type="text"
        helpText="Find the policy number on Equinor’s intranet"
        tracking={false}
        error={errors.customerDetail?.policyNumber}
      />
      <Input
        name="customerDetail.fullName"
        control={control}
        labelText="Full name"
        type="text"
        tracking={false}
        error={errors.customerDetail?.fullName}
      />
      <Input
        name="customerDetail.dateOfBirth"
        control={control}
        labelText="Date of birth"
        type="text"
        placeholder="dd/mm/yyyy"
        tracking={false}
        error={errors.customerDetail?.dateOfBirth}
      />
      <Input
        name="customerDetail.emailAddress"
        control={control}
        labelText="Email address"
        type="email"
        tracking={false}
        error={errors.customerDetail?.emailAddress}
      />
      <Input
        name="customerDetail.phoneNumber"
        control={control}
        labelText="Phone number"
        type="text"
        tracking={false}
        error={errors.customerDetail?.phoneNumber}
      />
      <Input
        name="customerDetail.postAddress"
        control={control}
        labelText="Post address"
        type="text"
        tracking={false}
        error={errors.customerDetail?.postAddress}
      />
      <Input
        name="customerDetail.postalCode"
        control={control}
        labelText="Postal code"
        type="text"
        tracking={false}
        error={errors.customerDetail?.postalCode}
      />
      <Input
        name="customerDetail.city"
        control={control}
        labelText="City"
        type="text"
        tracking={false}
        error={errors.customerDetail?.city}
      />
      <Input
        name="customerDetail.country"
        control={control}
        labelText="Country"
        type="text"
        tracking={false}
        error={errors.customerDetail?.country}
      />
      <Input
        name="customerDetail.bankAccountNumber"
        control={control}
        labelText="Bank account number"
        type="text"
        helpText="For non-Norwegian bank accounts, please provide an international bank account number, e.g. IBAN"
        tracking={false}
        error={errors.customerDetail?.bankAccountNumber}
      />
      <Input
        name="customerDetail.swift"
        control={control}
        labelText="Swift - Optional"
        type="text"
        helpText="Non-Norwegian bank account only. Swift code is provided by your bank."
        tracking={false}
        error={errors.customerDetail?.swift}
      />
      <Input
        name="customerDetail.bankAccountCountry"
        control={control}
        labelText="In which country do you have your bank account?"
        type="text"
        tracking={false}
        error={errors.customerDetail?.bankAccountCountry}
      />
    </Box>
  );
};
